// Automatically generated based off models.kt
@file:OptIn(ExperimentalSerializationApi::class, InternalSerializationApi::class)
@file:Suppress("UnusedImport", "UNCHECKED_CAST")

package com.ilussobsa

import com.lightningkite.*
import com.lightningkite.Length.Companion.miles
import com.lightningkite.lightningdb.*
import com.lightningkite.lightningserver.files.*
import com.lightningkite.serialization.*
import kotlin.jvm.JvmInline
import kotlin.math.roundToInt
import kotlin.time.Duration.Companion.seconds
import kotlinx.datetime.*
import kotlinx.serialization.Serializable
import kotlinx.serialization.UseContextualSerialization
import kotlin.io.encoding.Base64
import kotlin.io.encoding.ExperimentalEncodingApi
import com.lightningkite.serialization.DataClassPath
import com.lightningkite.serialization.DataClassPathSelf
import com.lightningkite.serialization.SerializableProperty
import kotlin.reflect.*
import kotlinx.serialization.*
import kotlinx.serialization.builtins.*
import kotlinx.serialization.internal.GeneratedSerializer

// Contextual types: kotlinx.datetime.Instant, com.lightningkite.UUID, com.lightningkite.lightningserver.files.ServerFile, kotlinx.datetime.LocalDate
fun prepareNotificationFields() {
    val props: Array<SerializableProperty<Notification, *>> = arrayOf(Notification__id, Notification_receiver, Notification_title, Notification_content, Notification_topic, Notification_link, Notification_at)
    Notification.serializer().properties { props }
}
val <K> DataClassPath<K, Notification>._id: DataClassPath<K, UUID> get() = this[Notification__id]
val <K> DataClassPath<K, Notification>.receiver: DataClassPath<K, UUID> get() = this[Notification_receiver]
val <K> DataClassPath<K, Notification>.title: DataClassPath<K, String> get() = this[Notification_title]
val <K> DataClassPath<K, Notification>.content: DataClassPath<K, String?> get() = this[Notification_content]
val <K> DataClassPath<K, Notification>.topic: DataClassPath<K, NotificationTopic> get() = this[Notification_topic]
val <K> DataClassPath<K, Notification>.link: DataClassPath<K, String?> get() = this[Notification_link]
val <K> DataClassPath<K, Notification>.at: DataClassPath<K, Instant> get() = this[Notification_at]
inline val Notification.Companion.path: DataClassPath<Notification, Notification> get() = path<Notification>()


object Notification__id: SerializableProperty<Notification, UUID> {
    override val name: String by lazy { Notification.serializer().descriptor.getElementName(0) }
    override fun get(receiver: Notification): UUID = receiver._id
    override fun setCopy(receiver: Notification, value: UUID) = receiver.copy(_id = value)
    override val serializer: KSerializer<UUID> by lazy { (Notification.serializer() as GeneratedSerializer<*>).childSerializers()[0] as KSerializer<UUID> }
    override val annotations: List<Annotation> by lazy { Notification.serializer().descriptor.getElementAnnotations(0) }
    override val default: UUID = uuid()
    override val defaultCode: String? = "uuid()" 
}
object Notification_receiver: SerializableProperty<Notification, UUID> {
    override val name: String by lazy { Notification.serializer().descriptor.getElementName(1) }
    override fun get(receiver: Notification): UUID = receiver.receiver
    override fun setCopy(receiver: Notification, value: UUID) = receiver.copy(receiver = value)
    override val serializer: KSerializer<UUID> by lazy { (Notification.serializer() as GeneratedSerializer<*>).childSerializers()[1] as KSerializer<UUID> }
    override val annotations: List<Annotation> by lazy { Notification.serializer().descriptor.getElementAnnotations(1) }
}
object Notification_title: SerializableProperty<Notification, String> {
    override val name: String by lazy { Notification.serializer().descriptor.getElementName(2) }
    override fun get(receiver: Notification): String = receiver.title
    override fun setCopy(receiver: Notification, value: String) = receiver.copy(title = value)
    override val serializer: KSerializer<String> by lazy { (Notification.serializer() as GeneratedSerializer<*>).childSerializers()[2] as KSerializer<String> }
    override val annotations: List<Annotation> by lazy { Notification.serializer().descriptor.getElementAnnotations(2) }
}
object Notification_content: SerializableProperty<Notification, String?> {
    override val name: String by lazy { Notification.serializer().descriptor.getElementName(3) }
    override fun get(receiver: Notification): String? = receiver.content
    override fun setCopy(receiver: Notification, value: String?) = receiver.copy(content = value)
    override val serializer: KSerializer<String?> by lazy { (Notification.serializer() as GeneratedSerializer<*>).childSerializers()[3] as KSerializer<String?> }
    override val annotations: List<Annotation> by lazy { Notification.serializer().descriptor.getElementAnnotations(3) }
    override val default: String? = null
    override val defaultCode: String? = "null" 
}
object Notification_topic: SerializableProperty<Notification, NotificationTopic> {
    override val name: String by lazy { Notification.serializer().descriptor.getElementName(4) }
    override fun get(receiver: Notification): NotificationTopic = receiver.topic
    override fun setCopy(receiver: Notification, value: NotificationTopic) = receiver.copy(topic = value)
    override val serializer: KSerializer<NotificationTopic> by lazy { (Notification.serializer() as GeneratedSerializer<*>).childSerializers()[4] as KSerializer<NotificationTopic> }
    override val annotations: List<Annotation> by lazy { Notification.serializer().descriptor.getElementAnnotations(4) }
    override val default: NotificationTopic = NotificationTopic.System
    override val defaultCode: String? = "NotificationTopic.System" 
}
object Notification_link: SerializableProperty<Notification, String?> {
    override val name: String by lazy { Notification.serializer().descriptor.getElementName(5) }
    override fun get(receiver: Notification): String? = receiver.link
    override fun setCopy(receiver: Notification, value: String?) = receiver.copy(link = value)
    override val serializer: KSerializer<String?> by lazy { (Notification.serializer() as GeneratedSerializer<*>).childSerializers()[5] as KSerializer<String?> }
    override val annotations: List<Annotation> by lazy { Notification.serializer().descriptor.getElementAnnotations(5) }
    override val default: String? = null
    override val defaultCode: String? = "null" 
}
object Notification_at: SerializableProperty<Notification, Instant> {
    override val name: String by lazy { Notification.serializer().descriptor.getElementName(6) }
    override fun get(receiver: Notification): Instant = receiver.at
    override fun setCopy(receiver: Notification, value: Instant) = receiver.copy(at = value)
    override val serializer: KSerializer<Instant> by lazy { (Notification.serializer() as GeneratedSerializer<*>).childSerializers()[6] as KSerializer<Instant> }
    override val annotations: List<Annotation> by lazy { Notification.serializer().descriptor.getElementAnnotations(6) }
    override val default: Instant = now()
    override val defaultCode: String? = "now()" 
}
